export default "__VITE_ASSET__30a236be__"